import React from 'react';
import { dpsTheme } from '../../../styles/dpsTheme';

interface SidebarItem {
  id: string;
  label: string;
  icon: JSX.Element;
}

interface DPSSidebarProps {
  activeSection: string;
  onSectionClick: (sectionId: string) => void;
}

export const DPSSidebar: React.FC<DPSSidebarProps> = ({ activeSection, onSectionClick }) => {
  const items: SidebarItem[] = [
    {
      id: 'vulnerabilities',
      label: 'Vulnérabilités',
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      ),
    },
    {
      id: 'risk',
      label: 'Risque local',
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
    },
  ];

  return (
    <aside
      style={{
        position: 'sticky',
        top: '120px',
        height: 'fit-content',
        background: dpsTheme.colors.background.card,
        backdropFilter: 'blur(20px)',
        border: `1px solid ${dpsTheme.colors.border.primary}`,
        borderRadius: dpsTheme.borderRadius.md,
        padding: dpsTheme.spacing.xl,
      }}
    >
      <div
        style={{
          fontSize: dpsTheme.typography.fontSize.sm,
          fontWeight: dpsTheme.typography.fontWeight.semibold,
          color: dpsTheme.colors.text.muted,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          marginBottom: dpsTheme.spacing.lg,
        }}
      >
        Navigation
      </div>
      {items.map((item) => (
        <div
          key={item.id}
          onClick={() => onSectionClick(item.id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: dpsTheme.spacing.md,
            padding: dpsTheme.spacing.md,
            borderRadius: '8px',
            color: activeSection === item.id ? dpsTheme.colors.accent.blue.secondary : dpsTheme.colors.text.tertiary,
            fontSize: dpsTheme.typography.fontSize.base,
            fontWeight: dpsTheme.typography.fontWeight.medium,
            transition: 'all 0.2s',
            cursor: 'pointer',
            marginBottom: '4px',
            background: activeSection === item.id ? dpsTheme.colors.accent.blue.bg : 'transparent',
            borderLeft: activeSection === item.id ? `3px solid ${dpsTheme.colors.accent.blue.primary}` : '3px solid transparent',
          }}
          onMouseEnter={(e) => {
            if (activeSection !== item.id) {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
              e.currentTarget.style.color = dpsTheme.colors.text.primary;
            }
          }}
          onMouseLeave={(e) => {
            if (activeSection !== item.id) {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = dpsTheme.colors.text.tertiary;
            }
          }}
        >
          {item.icon}
          {item.label}
        </div>
      ))}
    </aside>
  );
};